<template>
    <b-row>
        <b-col md="4">
            <b-card class="card-custom card-stretch">
                <!--User info-->
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                        <div class="symbol-label" :style="{backgroundImage: `url(${photo})`}"></div>
                    </div>
                    <div>
                        <a class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">
                            {{userData.UserName || ""}}
                        </a>
                        <div class="text-muted">
                            {{userData.UserGroup || ""}}
                        </div>
                    </div>
                </div>
                <!--Navigation-->
                <div class="pt-9 navi navi-bold navi-hover navi-active navi-link-rounded">
                    <div class="navi-item mb-2">
                        <a :class="(activeTab===0) ? 'navi-link py-4 active': 'navi-link py-4'"
                           style="cursor:pointer" @click="activeTab=0"
                        >
                            <span class="navi-icon mr-2">
                                <span class="svg-icon">
                                    <inline-svg src="media/svg/icons/General/User.svg"/>
                                </span>
                            </span>
                            <span class="navi-text font-size-lg">Общая информация</span>
                        </a>
                    </div>
                </div>
                <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
                    <div class="navi-item mb-2">
                        <a :class="(activeTab===1) ? 'navi-link py-4 active': 'navi-link py-4'"
                           style="cursor:pointer" @click="activeTab=1"
                        >
                            <span class="navi-icon mr-2">
                                <span class="svg-icon">
                                    <inline-svg src="media/svg/icons/Communication/Shield-user.svg"/>
                                </span>
                            </span>
                            <span class="navi-text font-size-lg">Пароль</span>
                        </a>
                    </div>
                </div>
                <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
                    <div class="navi-item mb-2">
                        <a :class="(activeTab===2) ? 'navi-link py-4 active': 'navi-link py-4'"
                           style="cursor:pointer" @click="activeTab=2"
                        >
                            <span class="navi-icon mr-2">
                                <span class="svg-icon">
                                    <inline-svg src="media/svg/icons/Code/Settings4.svg"/>
                                </span>
                            </span>
                            <span class="navi-text font-size-lg">Настройки аккаунта</span>
                        </a>
                    </div>
                </div>
            </b-card>
        </b-col>
        <b-col md="8">
            <AccountInformation v-if="activeTab===0"/>
            <AccountPassword v-if="activeTab===1"/>
            <AccountSettings v-if="activeTab===2"/>
        </b-col>
    </b-row>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import AccountInformation from "@/view/pages/profile/AccountInformation"
    import AccountPassword from "@/view/pages/profile/AccountPassword"
    import AccountSettings from "@/view/pages/profile/AccountSettings"

    export default {
        name: "Profile",
        components: {AccountInformation, AccountPassword, AccountSettings},
        data() {
            return {
                userData: this.$store.getters.getUserData,

                activeTab: 0,
                photo: "#",
            }
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{title: "Профиль"}]);
            this.photo = this.userData.UserPhotoUrl
        },
        methods: {}
    }
</script>

<style scoped>

</style>